module.exports = "/images/14K-RG.webp?351ffb0e9c67f543d686de7ebe6edec4";